// Template273: Pekín - Día 3 p.2 (Dia3MapaPekin.jsx)
// Imagen + tip + sticker, intro, lista tramos (Huanghuacheng, Jinshanling, Simatai), párrafo tarde, bloque Mercado de la Seda + SabiasQue.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template273 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const tipImage = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const paragraphTarde = page?.texts?.[3]?.content;
	const titleMercado = page?.texts?.[4]?.content;
	const bodyMercado = page?.texts?.[5]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const sticker = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");

	const tramos = Array.isArray(page?.data?.tramos) ? page.data.tramos : [];
	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Imagen + tip + sticker */}
			{img1 && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={img1}
						alt="Muralla"
						sx={{
							width: "100%",
							height: 150,
							objectFit: "cover",
							marginBottom: 0.5,
						}}
					/>
					{tipImage && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 60 : 75,
								left: 18,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 300,
								zIndex: 3,
							}}
						>
							{tipImage}
						</Box>
					)}
					{sticker && (
						<Box
							component="img"
							src={sticker}
							alt="sticker"
							sx={{
								width: 100,
								position: "absolute",
								bottom: 0,
								left: -10,
								zIndex: 2,
							}}
						/>
					)}
				</Box>
			)}

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: 2,
					position: "relative",
					flex: 1,
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1.5 }}>
						{intro}
					</Box>
				)}

				{/* Lista tramos */}
				{tramos.length > 0 && (
					<Box data-block-id="text-2" sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
						{tramos.map((t) => (
							<Box
								key={t.nombre}
								sx={{
									backgroundColor: "#fff",
									borderRadius: "12px",
									padding: "12px 14px",
									border: "2px solid #e8e8e8",
								}}
							>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										flexWrap: "wrap",
										gap: 1,
										marginBottom: 1,
									}}
								>
									<Box component="h3" sx={estiloH3}>
										{t.nombre}
									</Box>
									<Box
										component="span"
										sx={{
											fontSize: 11,
											color: "#666",
											marginLeft: "auto",
											display: "flex",
											alignItems: "center",
											gap: 0.5,
										}}
									>
										⏱️ {t.tiempo} desde Pekín
									</Box>
								</Box>
								{t.desc && (
									<Box
										component="p"
										sx={{ ...estiloP, fontSize: 12, margin: 0 }}
									>
										{t.desc}
									</Box>
								)}
							</Box>
						))}
					</Box>
				)}

				{paragraphTarde && (
					<Box
						data-block-id="text-3"
						component="p"
						sx={{ ...estiloP, marginTop: 1.5, marginBottom: 1.5 }}
					>
						{paragraphTarde}
					</Box>
				)}

				{/* Mercado de la Seda */}
				{(titleMercado || bodyMercado) && (
					<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{sabiasQue[0] && (
							<Box
								sx={{
									position: "absolute",
									top: -10,
									left: isSmallScreen ? "55%" : "32%",
								}}
							>
								<SabiasQue
									icono={sabiasQue[0].icono}
									texto={sabiasQue[0].texto}
								/>
							</Box>
						)}
						<Box
							sx={{
								width: "100%",
								padding: 1.5,
								backgroundColor: "#fde1e0",
								borderRadius: "12px",
							}}
						>
							{titleMercado && (
								<Box component="h3" sx={estiloH3}>
									{titleMercado}
								</Box>
							)}
							{bodyMercado && (
								<Box component="p" sx={{ ...estiloP, margin: 0 }}>
									{bodyMercado}
								</Box>
							)}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template273.thumbnail = "/images/template-1.png";
export default Template273;
